import { render, staticRenderFns } from "./ExPositionModal.vue?vue&type=template&id=0bb6e4fd"
import script from "./ExPositionModal.vue?vue&type=script&lang=js"
export * from "./ExPositionModal.vue?vue&type=script&lang=js"
import style0 from "./ExPositionModal.vue?vue&type=style&index=0&id=0bb6e4fd&prod&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports